var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkillLibraries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5241 19.6875H27.6553V15C27.6553 14.4825 27.2367 14.0625 26.7209 14.0625H16.4427V10.3125H18.3114C18.8272 10.3125 19.2458 9.8925 19.2458 9.375V3.75C19.2458 3.2325 18.8272 2.8125 18.3114 2.8125H12.7051C12.1893 2.8125 11.7707 3.2325 11.7707 3.75V9.375C11.7707 9.8925 12.1893 10.3125 12.7051 10.3125H14.5739V14.0625H4.29565C3.77987 14.0625 3.36126 14.4825 3.36126 15V19.6875H1.49249C0.97671 19.6875 0.558105 20.1075 0.558105 20.625V26.25C0.558105 26.7675 0.97671 27.1875 1.49249 27.1875H7.0988C7.61458 27.1875 8.03319 26.7675 8.03319 26.25V20.625C8.03319 20.1075 7.61458 19.6875 7.0988 19.6875H5.23003V15.9375H14.5739V19.6875H12.7051C12.1893 19.6875 11.7707 20.1075 11.7707 20.625V26.25C11.7707 26.7675 12.1893 27.1875 12.7051 27.1875H18.3114C18.8272 27.1875 19.2458 26.7675 19.2458 26.25V20.625C19.2458 20.1075 18.8272 19.6875 18.3114 19.6875H16.4427V15.9375H25.7865V19.6875H23.9177C23.402 19.6875 22.9834 20.1075 22.9834 20.625V26.25C22.9834 26.7675 23.402 27.1875 23.9177 27.1875H29.5241C30.0398 27.1875 30.4584 26.7675 30.4584 26.25V20.625C30.4584 20.1075 30.0398 19.6875 29.5241 19.6875Z",
    fill: "#7040c2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.9003,
    height: 30,
    fill: "white",
    transform: "translate(0.558105)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillLibraries);
export default __webpack_public_path__ + "static/media/skill-libraries.bc15b33c6f99086634524652adc2bf35.svg";
export { ForwardRef as ReactComponent };